import React from 'react';
import useAuth from '../hooks/useAuth';

const Profile: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      <div className="bg-white border border-slate-200 rounded-[16px] shadow-sm p-8 max-w-2xl">
        <h1 className="text-2xl font-extrabold text-slate-900 mb-6">User Profile Settings</h1>
        
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">First Name</label>
            <input type="text" readOnly value={user?.first_name || ''} className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-2.5 text-slate-800 outline-none" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">Last Name</label>
            <input type="text" readOnly value={user?.last_name || ''} className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-2.5 text-slate-800 outline-none" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">Email Address</label>
            <input type="email" readOnly value={user?.email || ''} className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-2.5 text-slate-800 outline-none" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">System Role</label>
            <input type="text" readOnly value={user?.role?.replace('_', ' ').toUpperCase() || ''} className="w-full bg-indigo-50 border border-indigo-100 text-indigo-700 font-bold rounded-lg px-4 py-2.5 outline-none" />
          </div>
          <div className="pt-4 border-t border-slate-100">
            <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2.5 px-6 rounded-lg w-full transition-colors">
              Request Profile Update
            </button>
            <p className="text-xs text-slate-400 mt-3 text-center">To change your email or role, please contact the Superadmin.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
